var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 70,
    cy: 70.5,
    r: 70,
    fill: "#38879F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9997 80.2856C84.3771 80.2856 95.6663 82.4594 95.6663 90.8462C95.6663 99.236 84.3031 101.333 70.9997 101.333C57.6253 101.333 46.333 99.1589 46.333 90.7722C46.333 82.3823 57.6963 80.2856 70.9997 80.2856ZM70.9997 39.666C80.0619 39.666 87.3228 46.9243 87.3228 55.9801C87.3228 65.0359 80.0619 72.2973 70.9997 72.2973C61.9405 72.2973 54.6766 65.0359 54.6766 55.9801C54.6766 46.9243 61.9405 39.666 70.9997 39.666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.aab91907272a23531b43b0f2a3f45f4c.svg";
export { ForwardRef as ReactComponent };